import { useEffect, useState } from "react";
import QRCode from "qrcode";

const INK = "#18181B";

export function GuestPassQr({
  value,
  size = 220,
}: {
  value: string;
  size?: number;
}) {
  const [src, setSrc] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    setError("");
    QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      color: { dark: INK, light: "#FFFFFF" },
    })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setError("QRの表示に失敗しました。下のURLをコピーしてください。");
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (error) {
    return <p style={{ color: "#BE123C", fontSize: 12.5 }}>{error}</p>;
  }
  if (!src) {
    return <p style={{ color: "#71717A", fontSize: 12.5 }}>QRを準備しています…</p>;
  }
  return (
    <img
      src={src}
      alt="ゲスト入場用QRコード"
      width={size}
      height={size}
      style={{ display: "block", width: size, height: size }}
    />
  );
}
